module.exports = __webpack_public_path__ + "static/roofing-19ecfbc4ecca20dca6a25b2a36636b2f.jpg";